import { createExclusionGroupFcmConfig } from '../shared/builders/exclusionGroup';
import type { FcmConfig } from '../shared/types';

const { name, normalizer, defaultValue } = createExclusionGroupFcmConfig('promote_page_exclusion_group');

export const FCM_PROMOTE_PAGE_EXCLUSION_GROUP: FcmConfig<typeof defaultValue, typeof defaultValue> = {
	name,
	normalizer,
	defaultValue,
	owner: 'squad-koi',
	scope: 'corgi-front-end',
	context: 'Promote page',
	description:
		'Exclusion group for CHANGE-96728: keeps a session bucketed into at most one experiment among promote_page_dynamic_pricing_experiment, promote_hero_feed_amount_experiment, promote_amount_buttons_simplified_experiment, and promote_bonus_banner_experiment. Each of those experiments only checks itself against this group when its own exclusion_group_experiment_id is set (unset means it runs unconditionally, bypassing the group). Defaults to no members (all experiments effectively disabled) until weights are set via this admin page.',
	template: {
		members: [
			{ experimentId: 'promote_page_dynamic_pricing_experiment', weight: 1 / 2 },
			{ experimentId: 'promote_hero_feed_amount_experiment', weight: 1 / 2 },
		],
	},
};
